<h4 class="text-center">Reports</h4>
<app-bar-chart-weekly-report *ngIf="ppReport['data'].length>0" [dataList]="ppReport['data']"  ></app-bar-chart-weekly-report>

<div class="table-responsive" *ngIf="ppReport['data'].length>0">
    <table datatable [dtOptions]="dtOptions" class="table table-striped display compact" id="assetTable">
        <tr>
            <td>Week Starting</td>
            <td> Week Ending</td>
            <td> Quiz Done </td>
            <td> questions Passed </td>
            <td> Average </td>
        </tr>
<tr *ngFor="let myDate of ppReport['data']; index as myCount">
   <td> {{myDate.weekstart}}</td>
   <td> {{myDate.weekend}} </td> 
   <td> {{myDate.quiz_attempted_count}} </td> 
   <td> {{myDate.questions_passed_count}} </td> 
   <td> {{myDate.questions_passed_average}} </td> 
   
</tr>
</table>
</div>
<div class="table-responsive" *ngIf="ppReport['data'].length<=0">
No Reports Found
</div>
